import styled from 'styled-components';

export const StyledPaletteBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background-color: rgba(9, 15, 56, 0.32);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 14vh;
  animation: paletteFade 160ms ease;
  @keyframes paletteFade {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const StyledPalettePanel = styled.div`
  width: min(640px, 92vw);
  background-color: var(--surface);
  border-radius: var(--r-xl);
  border: 1px solid var(--line);
  box-shadow: var(--sh-4);
  overflow: hidden;
  animation: palettePop 200ms cubic-bezier(0.34, 1.56, 0.64, 1);
  @keyframes palettePop {
    from { opacity: 0; transform: translateY(-8px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
`;

export const StyledPaletteInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--line);
  color: var(--muted-2);
  svg {
    width: 1.125rem;
    height: 1.125rem;
    flex-shrink: 0;
  }
`;

export const StyledPaletteInput = styled.input`
  flex: 1;
  font: inherit;
  font-size: var(--t-base);
  background: transparent;
  border: 0;
  outline: 0;
  color: var(--ink);
  &::placeholder {
    color: var(--muted-2);
  }
`;

export const StyledPaletteHint = styled.kbd`
  font: inherit;
  font-size: 0.6875rem;
  font-weight: var(--weight-medium);
  padding: 0.125rem 0.4rem;
  border-radius: var(--r-xs);
  border: 1px solid var(--line-2);
  background-color: var(--paper);
  color: var(--muted);
`;

export const StyledPaletteList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0.375rem;
  max-height: 22rem;
  overflow-y: auto;
`;

export const StyledPaletteGroup = styled.div`
  padding: 0.5rem 0.75rem 0.25rem;
  font-size: 0.625rem;
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  color: var(--muted-2);
`;

export const StyledPaletteItem = styled.li<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--r-sm);
  cursor: pointer;
  font-size: var(--t-base);
  color: var(--ink);
  background-color: ${({ active }) => active ? 'var(--brand-green-soft)' : 'transparent'};
  transition: background-color 100ms ease;
  svg {
    width: 1.125rem;
    height: 1.125rem;
    color: ${({ active }) => active ? 'var(--brand-green)' : 'var(--muted)'};
    flex-shrink: 0;
  }
  &:hover {
    background-color: var(--paper);
  }
`;

export const StyledPaletteItemBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
  flex: 1;
`;

export const StyledPaletteItemTitle = styled.span`
  font-weight: var(--weight-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledPaletteItemMeta = styled.span`
  font-size: 0.75rem;
  color: var(--muted);
`;

export const StyledPaletteEmpty = styled.div`
  padding: 1.5rem 1rem;
  text-align: center;
  color: var(--muted);
  font-size: var(--t-sm);
`;

export const StyledPaletteFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-top: 1px solid var(--line);
  font-size: 0.6875rem;
  color: var(--muted-2);
`;

export const StyledPaletteFooterGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
`;
